import { implementService } from '@wix/services-definitions';
import { ProvideComponentServiceDefinition, } from './definition.js';
import { createElement, Fragment } from 'react';
export const ProvideComponentServiceFactory = implementService(ProvideComponentServiceDefinition, ({ config }) => {
    const topComponents = config.topComponents || [];
    const bottomComponents = config.bottomComponents || [];
    const addTopComponent = (Comp) => {
        topComponents.push(Comp);
    };
    const addBottomComponent = (Comp) => {
        bottomComponents.push(Comp);
    };
    const getAllTopComponents = () => () => createElement(Fragment, null, topComponents.map((Comp, index) => createElement(Comp, { key: index })));
    const getAllBottomComponents = () => () => createElement(Fragment, null, bottomComponents.map((Comp, index) => createElement(Comp, { key: index })));
    return {
        addTopComponent,
        addBottomComponent,
        getAllTopComponents,
        getAllBottomComponents,
    };
});
